module.exports = __webpack_public_path__ + "fonts/Roboto-MediumItalic.c16d19c2.ttf";